/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_contact_proposal_body_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe the tool and the problem it solves. The more detail, the better.`)
};

const es_contact_proposal_body_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe la herramienta y el problema que resuelve. Cuantos más detalles, mejor.`)
};

const de_contact_proposal_body_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibe das Tool und das Problem, das es löst. Je mehr Details, desto besser.`)
};

const nl_contact_proposal_body_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschrijf de tool en het probleem dat hij oplost. Hoe meer details, hoe beter.`)
};

const fr_contact_proposal_body_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décrivez l'outil et le problème qu'il résout. Plus il y a de détails, mieux c'est.`)
};

const it_contact_proposal_body_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrivi lo strumento e il problema che risolve. Più dettagli, meglio è.`)
};

const pt_br2_contact_proposal_body_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descreva a ferramenta e o problema que ela resolve. Quanto mais detalhes, melhor.`)
};

const pt_contact_proposal_body_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descreve a ferramenta e o problema que resolve. Quantos mais detalhes, melhor.`)
};

const ja_contact_proposal_body_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ツールと、それが解決する問題を説明してください。詳しいほど助かります。`)
};

const zh_contact_proposal_body_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`描述这个工具以及它解决的问题。越详细越好。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const contact_proposal_body_hint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_proposal_body_hint(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("contact_proposal_body_hint", locale)
	if (locale === "en") return en_contact_proposal_body_hint(inputs)
	if (locale === "es") return es_contact_proposal_body_hint(inputs)
	if (locale === "de") return de_contact_proposal_body_hint(inputs)
	if (locale === "nl") return nl_contact_proposal_body_hint(inputs)
	if (locale === "fr") return fr_contact_proposal_body_hint(inputs)
	if (locale === "it") return it_contact_proposal_body_hint(inputs)
	if (locale === "pt-BR") return pt_br2_contact_proposal_body_hint(inputs)
	if (locale === "pt") return pt_contact_proposal_body_hint(inputs)
	if (locale === "ja") return ja_contact_proposal_body_hint(inputs)
	return zh_contact_proposal_body_hint(inputs)
};